document.querySelector('.footer__skip-link').addEventListener('click', function (e) {
  e.preventDefault();
  gsap.to(window, {duration: 3, scrollTo: 0, ease:"power4.inOut"});
});

function introAnim() {

  var controller = new ScrollMagic.Controller();
  var storyIntro = ".story-module.intro";
  var introText = ".story-module.intro .module-wrapper";

  new ScrollMagic.Scene({triggerElement: storyIntro, duration: "130%", triggerHook: .75})
    .setClassToggle(storyIntro, "active")
    // .addIndicators()
    .addTo(controller);

  new ScrollMagic.Scene({triggerElement: introText, duration: "100%", triggerHook: .75})
    .setClassToggle(introText, "active")
    // .addIndicators()
    .addTo(controller);
}

function quoteModuleAnim() {

  var controller = new ScrollMagic.Controller();
  var quoteModules = document.getElementsByClassName("quote-module");

  for (var i = 0; i < quoteModules.length; i++) {
    new ScrollMagic.Scene({triggerElement: quoteModules[i], duration: "300%", triggerHook: .55})
      .setClassToggle(quoteModules[i], "active")
      // .addIndicators()
      .addTo(controller);
  }
}
